import { FinancialData } from './financial-data';
import { FinancialType } from './financial-type';

export class FinancialTypeWithData extends FinancialType {
  financialData: FinancialData[];
}
